import OperationFormHandler from '@Modules/cardManagementSystem/smart/containers/formHandlers/globalParameters/scriptProcessingParameters/operation/OperationFormHandler';
import ReasonFormHandler from '@Modules/cardManagementSystem/smart/containers/formHandlers/globalParameters/scriptProcessingParameters/reason/ReasonFormHandler';
import ReasonPerOperationTableHandler from '@Modules/cardManagementSystem/smart/containers/tableHandlers/globalParameters/scriptProcessingParameters/reasonPerOperation/ReasonPerOperationTableHandler';
import StatusFormHandler from '@Modules/cardManagementSystem/smart/containers/formHandlers/globalParameters/scriptProcessingParameters/status/StatusFormHandler';
import MACGenerationParametersFormHandler from '@Modules/cardManagementSystem/smart/containers/formHandlers/globalParameters/scriptProcessingParameters/macGenerationParameters/MACGenerationParametersFormHandler';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import React from 'react';
import { Heading } from '@chakra-ui/react';
import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';


const tabHeaders = [
  'EMV Script ( Opération / Motif / Statut )',
  'Motif EMV Script Commande',
  'Parametres Generation MAC',
];

const Emv = <CC.SimpleGrid columns={{ base:1, md:3 }} gridRowGap={4} columnGap={10} my={4}>

<CustomFieldSet title='EMV Script Opération' >
  <OperationFormHandler />
</CustomFieldSet>

<CustomFieldSet title="Motif EMV Script" >
  <ReasonFormHandler />
</CustomFieldSet>

<CustomFieldSet title="Statut EMV Script" >
  <StatusFormHandler />
</CustomFieldSet>

</CC.SimpleGrid>

const EmvOrder = <CC.Box mt="2%" as="fieldset"
p={'2%'} border={'1px solid var(--chakra-colors-gray-300)'}>
  <CC.Heading px={2} as={"legend"} fontSize='md'>Motif EMV Script Commande</CC.Heading>
  <ReasonPerOperationTableHandler />
</CC.Box>

const MAC = <CC.Box mt="2%" as="fieldset"
p={'2%'} border={'1px solid var(--chakra-colors-gray-300)'}>
  <CC.Heading px={2} as={"legend"} fontSize='md'>Parametres Generation MAC</CC.Heading>
  <MACGenerationParametersFormHandler />
</CC.Box>

export default function ScriptProcessingParametersPage() {
  const tabContents = React.useMemo<React.ReactNode[]>(() => [
    Emv,
    EmvOrder,
    MAC,
  ], []);

  return (
    <>
      <Heading size="md" mb={'2rem'}>
        Parametres Script Processing
      </Heading>
      <CustomTabs tabHeaders={tabHeaders} tabContents={tabContents} />
    </>
  );
};